import { DAY_TO_MS } from './consts';

export default function getDaysAgo(days: number) {
  return new Date(Date.now() - DAY_TO_MS * days);
}
